export const AppName = 'AMZN Dashboard';
